































































import { RegistInfoDTO } from '@/api/com/MetaPattern/APP/MDA/User/RegistInfoDTO';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { EnumGender, EnumGenderMD } from '@/api/com/MetaPattern/APP/MDA/User/EnumGender';
import { EnumOrganizationType } from '@/api/com/MetaPattern/APP/MDA/User/EnumOrganizationType';
import { EnumTenancyType } from '@/api/com/MetaPattern/APP/MDA/User/EnumTenancyType';
import { MDAUserService } from '@/api/com/MetaPattern/APP/MDA/User/MDAUserService';
import { ValidateHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/ValidateHelper';

class RegistInfo {
  /** 登录名称 : 登录名称，全局唯一 */
  private _loginName: string;

  /** 设置：登录名称 */
  public get loginName() {
    return this._loginName;
  }

  /** 获取：登录名称 */
  public set loginName(value: string) {
    this._loginName = value;
  }

  /** 手机号 : 手机号 */
  private _mobile: string;

  /** 设置：手机号 */
  public get mobile() {
    return this._mobile;
  }

  /** 获取：手机号 */
  public set mobile(value: string) {
    this._mobile = value;
  }

  /** 邮件地址 : 邮件地址 */
  private _email: string;

  /** 设置：邮件地址 */
  public get email() {
    return this._email;
  }

  /** 获取：邮件地址 */
  public set email(value: string) {
    this._email = value;
  }

  /** 短信验证码 : 短信验证码 */
  private _sMSCode: string;

  /** 设置：短信验证码 */
  public get sMSCode() {
    return this._sMSCode;
  }

  /** 获取：短信验证码 */
  public set sMSCode(value: string) {
    this._sMSCode = value;
  }

  /** 昵称 : 昵称 */
  private _nickName: string;

  /** 设置：昵称 */
  public get nickName() {
    return this._nickName;
  }

  /** 获取：昵称 */
  public set nickName(value: string) {
    this._nickName = value;
  }

  /** 登录密码 : 登录密码 */
  private _password: string;

  /** 设置：登录密码 */
  public get password() {
    return this._password;
  }

  /** 获取：登录密码 */
  public set password(value: string) {
    this._password = value;
  }

  /** 确认登录密码 : 确认登录密码 */
  private _secPassword: string;

  /** 设置：确认登录密码 */
  public get secPassword() {
    return this._secPassword;
  }

  /** 获取：确认登录密码 */
  public set secPassword(value: string) {
    this._secPassword = value;
  }

  /** 姓名 : 个人的真实姓名 */
  private _personName: string;

  /** 设置：姓名 */
  public get personName() {
    return this._personName;
  }

  /** 获取：姓名 */
  public set personName(value: string) {
    this._personName = value;
  }

  /** 出生日期 : 出生日期 */
  private _birthday: string;

  /** 设置：出生日期 */
  public get birthday() {
    return this._birthday;
  }

  /** 获取：出生日期 */
  public set birthday(value: string) {
    this._birthday = value;
  }

  /** 性别 : 性别 */
  private _gender: string;

  /** 设置：性别 */
  public get gender() {
    return this._gender;
  }

  /** 获取：性别 */
  public set gender(value: string) {
    this._gender = value;
  }

  /** 机构名称 : 机构的完整名称 */
  private _orgName: string;

  /** 设置：机构名称 */
  public get orgName() {
    return this._orgName;
  }

  /** 获取：机构名称 */
  public set orgName(value: string) {
    this._orgName = value;
  }

  /** 机构类型 : 机构类型 */
  private _orgType: string;

  /** 设置：机构类型 */
  public get orgType() {
    return this._orgType;
  }

  /** 获取：机构类型 */
  public set orgType(value: string) {
    this._orgType = value;
  }

  /** 租户类型 : 租户类型 */
  private _tenancyType: string;

  /** 设置：租户类型 */
  public get tenancyType() {
    return this._tenancyType;
  }

  /** 获取：租户类型 */
  public set tenancyType(value: string) {
    this._tenancyType = value;
  }

  constructor() {
    this._loginName = '';
    this._mobile = '';
    this._email = '';
    this._sMSCode = '';
    this._nickName = '';
    this._password = '';
    this._secPassword = '';
    this._personName = '';
    this._gender = EnumGender.None.toString();
    this._orgName = '';
    this._orgType = EnumOrganizationType.Company.toString();
    this._tenancyType = EnumTenancyType.Person.toString();
    this._birthday = '';
  }
}

@Component({
  components: {
  }
})
export default class UserRegist extends Vue {
  private registForm: RegistInfo = null;

  constructor() {
    super();
    this.registForm = new RegistInfo();
  }

  regist() {
    (this.$refs.registForm as any).validate((valid: any) => {
      if (valid) {
        const dto = new RegistInfoDTO();
        if (this.registForm.birthday !== '') {
          dto.birthday = new Date(this.registForm.birthday);
        }
        dto.email = this.registForm.email;
        dto.tenancyType = EnumTenancyType.Person;
        if (this.registForm.orgName !== '') {
          dto.tenancyType = EnumTenancyType.Organization;
        }
        dto.gender = Number.parseInt(this.registForm.gender);
        dto.loginName = this.registForm.loginName;
        dto.mobile = this.registForm.mobile;
        dto.orgName = this.registForm.orgName;
        dto.orgType = Number.parseInt(this.registForm.orgType);
        dto.password = this.registForm.password;
        dto.personName = this.registForm.personName;
        dto.sMSCode = 'nouse'; // TODO：暂时先去掉手机验证码的功能
        MDAUserService.RegistUserAsync(dto)
          .then(response => {
            if (response !== null) {
              this.$alert('您已经成功注册，将跳转到登陆页面进行登录', '注册成功', {
                confirmButtonText: '确定',
                callback: action => {
                  this.goLogin();
                }
              });
            } else {
              this.$message({
                type: 'error',
                message: '注册失败，请检查注册信息'
              });
            }
          })
          .catch(err => {
            // 错误提示
            this.$message({
              type: 'error',
              message: `注册失败，原因是：${err}`
            });
          });
      }
    });
  }

  reset() {
    (this.$refs.registForm as any).resetFields();
  }

  goLogin() {
    this.$router.push('/Login');
  }

  get labelWidth() {
    return '100px';
  }

  validateLoginName(rule: any, value: string, callback: any) {
    ValidateHelper.validateExpressWithCallback('^[a-zA-Z]{1}[a-zA-Z0-9]{7,15}$', '必须至少8位且包含字母和数字，以字母开头，最长16位', value, callback);
  }

  validatePassword(rule: any, value: string, callback: any) {
    ValidateHelper.validateExpressWithCallback('^(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9~!@&%#_]{8,16}$', '必须至少8位且包含大小写字母和数字，最长16位', value, callback);
  }

  validateSecPassword(rule: any, value: string, callback: any) {
    if (value !== this.registForm.password) {
      callback(new Error('两次输入密码不一致!'));
    }
    callback();
  }

  validateMobile(rule: any, value: string, callback: any) {
    ValidateHelper.validateExpressWithCallback('^1[3456789]\\d{9}$', '填写合法的手机号码', value, callback);
  }

  validateEmail(rule: any, value: string, callback: any) {
    ValidateHelper.validateExpressWithCallback('^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$', '填写合法的电子邮件', value, callback);
  }
}
